import React from 'react';

export const BuzzfeedIcon = ({ className, title = 'BuzzFeed' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
    <title>{title}</title>
    <path d="M7.8125 15.625C12.1272 15.625 15.625 12.1272 15.625 7.8125C15.625 3.49778 12.1272 0 7.8125 0C3.49778 0 0 3.49778 0 7.8125C0 12.1272 3.49778 15.625 7.8125 15.625Z" fill="#EE3322"/>
    <path d="M11.9931 7.18563L11.4857 3.67163L8.11553 4.9994L9.45134 5.7525L8.1895 7.88679L6.00389 6.65452L3.85059 10.2968L5.05667 10.9768L6.51362 8.51237L8.69923 9.74464L10.6574 6.43253L11.9931 7.18563Z" fill="white"/>
  </svg>
);
